import React from 'react';
import LegacyTag, { TagProps } from './Tag.legacy';
import AlphaTag from './Tag.alpha';

const Component = process.env.IS_LEGACY ? LegacyTag : AlphaTag;
export default Component as React.FC<TagProps>;
export type { TagProps };
